const sources: Resource[] = [
    {
        name: 'computerModel',
        type: 'gltfModel',
        path: 'models/Computer/model.glb',
    },
    {
        name: 'pc08_baseColor',
        type: 'texture',
        path: 'models/Computer/tex/pc_08_-_Default_BaseColor.jpg',
    },
    {
        name: 'pc08_normal',
        type: 'texture',
        path: 'models/Computer/tex/pc_08_-_Default_Normal.jpg',
    },
    {
        name: 'pc08_roughness',
        type: 'texture',
        path: 'models/Computer/tex/pc_08_-_Default_Roughness.jpg',
    },
    {
        name: 'pc08_metallic',
        type: 'texture',
        path: 'models/Computer/tex/pc_08_-_Default_Metallic.png',
    },
    {
        name: 'pc09_baseColor',
        type: 'texture',
        path: 'models/Computer/tex/pc_09_-_Default_BaseColor.jpg',
    },
    {
        name: 'pc09_normal',
        type: 'texture',
        path: 'models/Computer/tex/pc_09_-_Default_Normal.jpg',
    },
    {
        name: 'pc09_roughness',
        type: 'texture',
        path: 'models/Computer/tex/pc_09_-_Default_Roughness.jpg',
    },
    {
        name: 'pc09_metallic',
        type: 'texture',
        path: 'models/Computer/tex/pc_09_-_Default_Metallic.png',
    },
];

export default sources;
